import axios from 'axios';
import {
  handleCookies,
} from '@/static/helpers';

import { serviceWrapper, serviceConfigs } from '@/services/configs';

export default {
  setUserInfo(user) {
    handleCookies.setCookie({
      hrvenue_userinfo: JSON.stringify(user),
    });
  },

  getUserInfo() {
    return handleCookies.getCookie('hrvenue_userinfo');
  },

  setToken(identity) {
    handleCookies.setCookie({
      hrvenue_identity: identity,
    });
    axios.defaults.headers.Authorization = `Bearer ${identity}`;
  },

  deleteToken() {
    // remove token cookie
    handleCookies.deleteCookie('hrvenue_identity');
    handleCookies.deleteCookie('hrvenue_userinfo');
    handleCookies.deleteCookie('email');
    handleCookies.deleteCookie('gsm');
    handleCookies.deleteCookie('userFullName');
    handleCookies.deleteCookieWithNativeJs('ManagementCredentialToken');
    handleCookies.deleteCookie('hrvenueCookie2S');
    handleCookies.deleteCookie('segment');
    localStorage.setItem('ga4_user_properties', JSON.stringify({
      user_id: null,
      user_login_status: 'no',
    }));
    localStorage.removeItem('selectedCompanyUser');
    localStorage.removeItem('showInfo');
    // set axios.default headers token value
    axios.defaults.headers.Authorization = null;
  },

  checkEmail() {
    const email = handleCookies.getCookie('email');

    return email;
  },

  checkGsm() {
    const gsm = handleCookies.getCookie('gsm');

    return gsm;
  },
  setOptionalOtp(status) {
    this.resetOptionalOtp();
    if (status) handleCookies.setCookie({ isOptionalOtp: status });
  },

  checkOptionalOtp() {
    const optionalOtp = handleCookies.getCookie('isOptionalOtp');

    return optionalOtp;
  },

  resetOptionalOtp() {
    handleCookies.deleteCookie('isOptionalOtp');
  },

  setOtp(status) {
    this.resetOtp();
    if (status) handleCookies.setCookie({ otpRequired: status });
  },

  checkOtp() {
    const otp = handleCookies.getCookie('otpRequired');

    return otp;
  },
  resetOtp() {
    handleCookies.deleteCookie('otpRequired');
  },
  check2fa() {
    const twofa = handleCookies.getCookie('twofaRequired');

    return twofa;
  },
  set2fa(status) {
    this.reset2fa();
    if (status) handleCookies.setCookie({ twofaRequired: status });
  },
  reset2fa() {
    handleCookies.deleteCookie('twofaRequired');
  },

  checkAuth() {
    const cookieToken = handleCookies.getCookie('hrvenue_identity');
    // check if cookie is empty
    if (cookieToken) {
      return true;
    }
    return false;
  },

  getTokenByCompanyId(params) {
    const apiPromise = serviceWrapper(
      serviceConfigs.account,
      serviceConfigs.account.getTokenByCompanyId,
      params,
    );

    apiPromise.then((response) => {
      if (response.data.statusCode === 200) {
        this.setToken(response.data.result.token);
        return response;
      }
    });

    return apiPromise;
  },
};
